import { Component, Input } from '@angular/core';
import { Series } from '@core/models/series.model';

@Component({
  selector: 'app-single-series-block',
  templateUrl: './single-series-block.component.html',
  styleUrl: './single-series-block.component.css',
})
export class SingleSeriesBlockComponent {
  @Input() series?: Series;
}
